<template>
  <div
    class="disable-double-tap container-cart"
    :class="!$route.query.embed ? 'pt-6' : ''"
  >
    <v-row
      v-if="!$route.query.embed"
      :class="!$vuetify.breakpoint.mdAndUp ? 'pb-6 px-6' : 'pb-6'"
      align="center"
      no-gutters
    >
      <span class="accent-text checkout-h2">{{ $t("cart.tickets") }}</span>
      <v-spacer></v-spacer>
      <span
        v-if="
          !(showCoupon || couponApplied) ||
          productsDetails?.isCupomTracking ||
          couponDetails?.cupomData?.campaign_type === 'programada'
        "
        class="secondary--text checkout-h5"
        style="cursor: pointer"
        @click="showCoupon = !showCoupon"
        >{{ $t("cart.applyCoupon") }}</span
      >
    </v-row>
    <v-row
      class="mb-6"
      v-if="(showCoupon || couponApplied) && !$route.query.embed"
      no-gutters
    >
      <Coupon
        :showCoupon="showCoupon"
        :couponApplied="couponApplied"
        @clear="clear"
        @hideInput="showCoupon = false"
      />
    </v-row>
    <div
      v-if="
        !$vuetify.breakpoint.mdAndUp ||
        sectors?.length ||
        haveProductsWithoutGroup
      "
      :class="$route.query.embed ? 'box-products-embeded' : 'box-products'"
    >
      <Sectors v-if="sectors?.length" :sectors="sectors" />
      <div v-if="!isExpand">
        <div v-for="(product, index) in noSectorList" :key="index">
          <NoExpandedProducts
            v-for="(type, i) in product.filter((t) => !t.nome_grupo)"
            :key="i"
            :type="type"
            :index="i"
            :indexProduct="index"
            :product="product"
            :eventDetails="eventDetails"
          />
        </div>
      </div>
      <ExpandedProducts
        v-else
        :noSectorList="noSectorList"
        :eventDetails="eventDetails"
      />
      <GroupedProducts
        v-if="!$vuetify.breakpoint.mdAndUp"
        :noSectorList="noSectorList"
        :eventDetails="eventDetails"
        :isExpand="isExpand"
      />
      <CardCampaign
        v-if="
          (!$vuetify.breakpoint.mdAndUp || $route.query.embed) &&
          eventDetails?.campanha_cartao &&
          !(showCoupon || couponApplied)
        "
        :eventDetails="eventDetails"
      />
      <v-divider v-if="$route.query.embed"></v-divider>
      <v-row
        v-if="$route.query.embed && !showCoupon"
        no-gutters
        class="pa-6"
        style="cursor: pointer"
        @click="showCoupon = !showCoupon"
      >
        <span class="primary--text">Aplicar Código</span>
      </v-row>
      <v-row
        v-if="(showCoupon || couponApplied) && $route.query.embed"
        :class="couponApplied && couponDetails ? 'py-2' : 'py-4'"
        no-gutters
      >
        <Coupon
          :showCoupon="showCoupon"
          :couponApplied="couponApplied"
          @clear="clear"
        />
      </v-row>
    </div>
    <GroupedProducts
      v-if="$vuetify.breakpoint.mdAndUp && !$route.query.embed"
      :noSectorList="noSectorList"
      :eventDetails="eventDetails"
      :isExpand="isExpand"
    />

    <div
      v-if="
        $vuetify.breakpoint.mdAndUp &&
        !$route.query.embed &&
        eventDetails?.campanha_cartao &&
        !(showCoupon || couponApplied)
      "
      class="box-products mt-4"
    >
      <CardCampaign :eventDetails="eventDetails" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Sectors from "./containerProductsAndSectors/Sectors.vue";
import ExpandedProducts from "./containerProductsAndSectors/ExpandedProducts.vue";
import NoExpandedProducts from "./containerProductsAndSectors/NoExpandedProducts.vue";
import GroupedProducts from "./containerProductsAndSectors/GroupedProducts.vue";
import Coupon from "./Coupon.vue";
import CardCampaign from "./containerProductsAndSectors/CardCampaign.vue";
export default {
  data() {
    return {
      showCoupon: false,
    };
  },
  computed: {
    ...mapGetters([
      "sectors",
      "noSectorList",
      "eventDetails",
      "couponApplied",
      "couponDetails",
      "productsDetails",
    ]),
    isExpand() {
      return !!(
        this.eventDetails && this.eventDetails.checkout_produtos_agrupados
      );
    },
    haveProductsWithoutGroup() {
      return !!this.noSectorList?.find((product) =>
        product.find((t) => !t.nome_grupo)
      );
    },
  },
  methods: {
    clear() {
      this.showCoupon = false;
    },
  },
  components: {
    Sectors,
    ExpandedProducts,
    NoExpandedProducts,
    GroupedProducts,
    Coupon,
    CardCampaign,
  },
};
</script>

<style scoped>
.box-products-embeded {
  border: 1px solid #dfdfdf;
  padding-bottom: 3px;
  padding-top: 3px;
}

.box-products {
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  padding-bottom: 3px;
  padding-top: 3px;
}
</style>
